// extracted by mini-css-extract-plugin
export default {"pageBlank":"obHWbD0yx7PfKWPksGcF","cactus":"HTbyM0JTmx9Pucfukouv"};